export default "__VITE_ASSET__CP1zWRzA__"